export default __webpack_public_path__ + "static/media/Summoner's Bands of Sovereign Rule.a4aee3cf.jpg";